export default __webpack_public_path__ + "static/media/four.8041b8c5.jpeg";